import { ComponentProps } from 'react'
import styled from 'styled-components'

import { LoadingSpinner } from '@syconium/little-miss-figgy'

const FormSubmitSpinner = styled(
  ({ size = '20px', ...rest }: ComponentProps<typeof LoadingSpinner>) => {
    return <LoadingSpinner size={size} {...rest} />
  }
)`
  position: absolute;
  inset: auto auto auto auto;
`

export const FormSubmitContent = styled(
  ({
    children,
    isSubmitting,
    submittingLabel,
    className,
  }: {
    children?: React.ReactNode
    isSubmitting: boolean
    submittingLabel: string
    className?: string
  }) => {
    return (
      <>
        <span className={className}>{children}</span>
        {isSubmitting ? <FormSubmitSpinner label={submittingLabel} /> : null}
      </>
    )
  }
)`
  ${o => (o.isSubmitting ? 'opacity: 0;' : '')};

  display: inline-flex;
  justify-content: center;
  align-items: center;
  column-gap: 0.6ch;
  flex-wrap: wrap;

  > * {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: auto;
  }
`
